import {
  LabelBinding,
  RequestDataOfCreateOrderRequest,
  RequestDataOfDiscontinueRequest,
  RequestDataOfGetOffersRequest2,
  ResponseDataOfCreateOrderResponse,
  ResponseDataOfDiscontinueIntakeResponse,
  ResponseDataOfDiscontinueResponse,
  ResponseDataOfGetDiscontinueReasonsResponse,
  ResponseDataOfGetOffersResponse2,
} from '@monorepo-types/dc/smartthermostat';

import { request } from '../../client';
import type { ApiRequestConfig } from '../../client/types';

type CreateOrder = {
  businessUnit: string;
  label: LabelBinding;
  customerId: number;
  accountId: number;
  requestBody: RequestDataOfCreateOrderRequest;
};
/**
 *
 *
 * @returns ResponseDataOfCreateOrderResponse OK
 */
export function createOrder(
  { businessUnit, label, customerId, accountId, requestBody }: CreateOrder,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseDataOfCreateOrderResponse> {
  return request(
    {
      method: 'POST',
      path: `/v1/smartthermostat/${businessUnit}/${label}/customers/${customerId}/accounts/${accountId}/sales/orders`,
      body: requestBody,
      errors: { 400: 'Bad Request', 403: 'Forbidden', 404: 'Not Found', 500: 'Internal Server Error' },
    },
    requestConfig,
  );
}

type GetOffers = { businessUnit: string; label: LabelBinding; requestBody: RequestDataOfGetOffersRequest2 };
/**
 *
 *
 * @returns ResponseDataOfGetOffersResponse2 OK
 */
export function getOffers(
  { businessUnit, label, requestBody }: GetOffers,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseDataOfGetOffersResponse2> {
  return request(
    {
      method: 'POST',
      path: `/v1/smartthermostat/public/${businessUnit}/${label}/sales/offers/query`,
      body: requestBody,
      errors: { 400: 'Bad Request', 404: 'Not Found', 500: 'Internal Server Error' },
    },
    requestConfig,
  );
}

type GetDiscontinueReasons = { businessUnit: string; label: LabelBinding };
/**
 *
 *
 * @returns ResponseDataOfGetDiscontinueReasonsResponse OK
 */
export function getDiscontinueReasons(
  { businessUnit, label }: GetDiscontinueReasons,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseDataOfGetDiscontinueReasonsResponse> {
  return request(
    {
      method: 'GET',
      path: `/v1/smartthermostat/public/${businessUnit}/${label}/sales/discontinue/reasons`,
      errors: { 500: 'Internal Server Error' },
    },
    requestConfig,
  );
}

type DiscontinueIntake = { businessUnit: string; label: LabelBinding; customerId: number };
/**
 *
 *
 * @returns ResponseDataOfDiscontinueIntakeResponse OK
 */
export function discontinueIntake(
  { businessUnit, label, customerId }: DiscontinueIntake,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseDataOfDiscontinueIntakeResponse> {
  return request(
    {
      method: 'GET',
      path: `/v1/smartthermostat/${businessUnit}/${label}/customers/${customerId}/sales/discontinue/intake`,
      errors: { 400: 'Bad Request', 404: 'Not Found', 500: 'Internal Server Error' },
    },
    requestConfig,
  );
}

type Discontinue = {
  businessUnit: string;
  label: LabelBinding;
  customerId: number;
  accountId: number;
  requestBody: RequestDataOfDiscontinueRequest;
};
/**
 *
 *
 * @returns ResponseDataOfDiscontinueResponse OK
 */
export function discontinue(
  { businessUnit, label, customerId, accountId, requestBody }: Discontinue,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseDataOfDiscontinueResponse> {
  return request(
    {
      method: 'POST',
      path: `/v1/smartthermostat/${businessUnit}/${label}/customers/${customerId}/accounts/${accountId}/sales/discontinue`,
      body: requestBody,
      errors: { 400: 'Bad Request', 403: 'Forbidden', 404: 'Not Found', 500: 'Internal Server Error' },
    },
    requestConfig,
  );
}
